// @flow
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { NotFound } from '@finect/tabular-components/NotFound';
import type { UserType } from '../../types';
import QuestionList from './QuestionList';

type Props = {
  location: {
    pathname: string,
    search: string,
    hash: string,
    state?: any,
    key?: string
  },
  user: UserType
};

export const Questions = ({ location, user }: Props) => {
  const { pathname } = location;
  const path = pathname.replace(/\/\s*$/, '');
  const privatePaths = ['/preguntas/mis-preguntas'];
  // const privatePaths = ['/preguntas/mis-preguntas', '/preguntas/guardadas'];
  if (!user.isLoggedIn && privatePaths.includes(path)) {
    return <Redirect to="/preguntas" />;
  }

  return (
    <Switch>
      <Route exact path="/preguntas/ultimas" render={props => <QuestionList type="latest" {...props} />} />
      <Route exact path="/preguntas/mas-activas" render={props => <QuestionList type="active" {...props} />} />
      {/* <Route exact path="/preguntas/mis-preguntas" render={props => <QuestionList type="mine" {...props} />} /> */}
      {/* <Route exact path="/preguntas/guardadas" render={props => <QuestionList type="followedQuestions" {...props} />} /> */}
      <Route exact path="/preguntas" render={props => <QuestionList type="active" {...props} />} />
      <Route render={props => <NotFound actionText="Ir a preguntas" redirectPath="/preguntas" {...props} />} />
    </Switch>
  );
};
